import React from 'react';
import BKModal from 'components/BKModal';

export const VKT_LOGO =
  'https://cdnc.lms360.vn/2026-03-27/ad91e9c9-da5c-46a6-a91e-41dd1766a341/content/assets/images/vien_khao_thi.png';

const SECTIONS = [
  {
    title: 'Khung đánh giá năng lực',
    body: 'Phân loại mức độ nhận thức (Nhận biết – Thông hiểu – Vận dụng) theo chuẩn của Bộ Giáo dục và Đào tạo, được tích hợp trực tiếp vào cấu trúc đề thi.'
  },
  {
    title: 'Chuẩn hóa quy tắc ra đề',
    body: 'Xây dựng nguyên tắc biên soạn cho các dạng câu hỏi: trắc nghiệm khách quan, đúng/sai, trả lời ngắn, tự luận (viết đoạn, viết bài). Chuẩn hóa mức độ theo năng lực: Dễ – Nhận biết; Trung bình – Thông hiểu; Khó – Vận dụng. Đáp ứng Chương trình Giáo dục phổ thông 2018.'
  },
  {
    title: 'Nền tảng nội dung cho AI',
    body: 'Bao gồm yêu cầu cần đạt, phân phối chương trình, thuật ngữ và các ngữ cảnh thực tiễn theo từng môn học và khối lớp, phục vụ trực tiếp cho việc sinh câu hỏi.'
  },
  {
    title: 'Đảm bảo chất lượng đầu ra',
    body: 'Đội ngũ chuyên môn từ Viện trực tiếp tham gia đánh giá, thẩm định và phản hồi, đảm bảo câu hỏi đạt chuẩn trước khi đưa vào sử dụng.'
  }
];

/**
 * Dialog giới thiệu Viện Khảo Thí (IEQTE).
 * Dùng chung cho VienKhaoThiBadge, trang đăng nhập, footer, v.v.
 */
export default function IEQTEDialog({ open, onClose }) {
  return (
    <BKModal
      open={open}
      onClose={onClose}
      title={
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <img
            src={VKT_LOGO}
            alt=""
            style={{ width: '32px', height: '32px', objectFit: 'contain' }}
          />
          <span>Viện Khảo thí và Đánh giá chất lượng giáo dục (IEQTE)</span>
        </div>
      }
      width={560}
      confirmClose={false}
      footer={null}>
      {/* Giới thiệu */}
      <p
        style={{
          fontSize: '13px',
          color: '#444',
          lineHeight: 1.7,
          marginBottom: '20px'
        }}>
        <a
          href="https://vienkhaothi.edu.vn/"
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: '#1890ff', textDecoration: 'underline' }}>
          Viện Khảo thí và Đánh giá chất lượng giáo dục (IEQTE)
        </a>
        {' '}là tổ chức khoa
        học và công nghệ trực thuộc Hiệp hội Các trường đại học, cao đẳng Việt
        Nam, được thành lập ngày 04 tháng 9 năm 2024. Viện có chức năng nghiên
        cứu, tư vấn xây dựng các chiến lược, chính sách về hoạt động khảo thí,
        đo lường và đánh giá chất lượng trong lĩnh vực giáo dục và đào tạo; tổ
        chức đào tạo, bồi dưỡng và cấp chứng nhận về khảo thí, đo lường và đánh
        giá, đánh giá năng lực và đánh giá chất lượng giáo dục.
      </p>

      {/* Tiêu đề đóng góp */}
      <div
        style={{
          fontSize: '13px',
          fontWeight: 600,
          color: '#1890ff',
          marginBottom: '12px',
          paddingBottom: '8px',
          borderBottom: '1px solid #e8e8e8'
        }}>
        Cung cấp nền tảng dữ liệu cho hệ thống tạo đề thi bằng AI
      </div>

      {/* Các mục đóng góp */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
        {SECTIONS.map((s) => (
          <div
            key={s.title}
            style={{
              background: '#f8fafc',
              border: '1px solid #e8e8e8',
              borderLeft: '3px solid #1890ff',
              borderRadius: '6px',
              padding: '10px 12px'
            }}>
            <div
              style={{
                fontSize: '13px',
                fontWeight: 600,
                color: '#262626',
                marginBottom: '4px'
              }}>
              {s.title}
            </div>
            <div
              style={{ fontSize: '13px', color: '#595959', lineHeight: 1.6 }}>
              {s.body}
            </div>
          </div>
        ))}
      </div>

    </BKModal>
  );
}
